import globals from '@/utils/globals';
import { computed, nextTick, ref, Ref } from 'vue';
import { IIncentiveV2Store } from '@/domain/dto/store.incentive-v2.interfaces';

export default class NameInput {
	public input: Ref<HTMLInputElement | null> = ref(null);
	public hasFocus = ref(false);

	public constructor(public store: IIncentiveV2Store) {}

	public name = computed((): string | null => {
		return this.store.getters.name();
	});

	public showNameError = computed((): boolean => {
		return this.store.getters.showNameError();
	});

	public updated(): void {
		// eslint-disable-next-line @typescript-eslint/no-floating-promises
		nextTick(() => {
			globals.eventBus.emit('authPopupCalculatePadding');
		});
	}

	public setFocusOnInput(): void {
		const inputElement = this.input.value;
		if (typeof inputElement === 'undefined') {
			return;
		}
		inputElement?.focus();
	}

	public setFocused(hasFocus: boolean): void {
		this.hasFocus.value = hasFocus;
	}

	public saveName(_isBlurEvent: boolean, event: Event): void {
		this.setFocused(false);
		this.store.actions.saveName((event.target as HTMLInputElement).value);
	}
}
